export default "__VITE_ASSET__Dy4wsqVi__ 100w";